import { createLicenseUser } from './create-license-user';
import { LicenseUser } from '../../models/license-user';
import { AccountSummary, FleetUser } from '@tmx/data-access';

export function createLicenseUsers(
  values: FleetUser[],
  accountSummary: AccountSummary
) {
  const licenseUsers: LicenseUser[] = [];
  for (const user of values) {
    licenseUsers.push(createLicenseUser(user, accountSummary));
  }
  return licenseUsers;
}
